<template>
    <ButtonGroup class="mb-2@large"><!-- mb-2@large: slightly larger gap after this group -->
      <a @click.prevent="goToPersonalisazion" target="_blank" class="btn w-100" :disabled="!configurationComplete">
        {{ 'ttxtDesignOnline'|translate }}
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.8 12.8" class="svg-icon ml-2 fill-white">
          <path d="M8.7 6.4c0 .2-.1.3-.2.5L5 10.7l-1-.9 3-3.4L4.1 3l1-.9 3.5 3.8c.1.2.1.3.1.5z" fill="#3a3a39"/>
        </svg>
      </a>
      <DownloadTemplate name="download-template" :conf3DModel="configuratorService.byConfigoptionType('Printq').dynamicValues.conf3DModel"
                        :printqService="this.printqService"
      >
        <a @click="$modal.show('download-template')" class="btn w-100" :disabled="!configurationComplete">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.92 12.76"
               class="svg-icon icon-download mr-2 fill-white">
            <path
                d="M.75 12.76a1 1 0 01-.51-.28.85.85 0 01-.24-.6V9a.85.85 0 011.19-.81.84.84 0 01.54.84v1.82c0 .14 0 .14.13.14h8.2c.13 0 .13 0 .13-.13V9.09a.87.87 0 01.36-.75.82.82 0 01.85-.09.8.8 0 01.51.67 1.21 1.21 0 010 .19v2.72a.89.89 0 01-.24.66.94.94 0 01-.43.25h-.08z"
                fill="#3a3a39" fill-rule="evenodd"/>
            <path
                d="M6.19 0a2.43 2.43 0 01.37.16.84.84 0 01.38.73v5.42l.22-.21c.3-.3.6-.61.91-.91a.85.85 0 011.07-.11.87.87 0 01.34 1 1.26 1.26 0 01-.35.47L7.72 8 6.65 9a.88.88 0 01-1.24 0L3.78 7.34c-.33-.33-.67-.66-1-1a.8.8 0 01-.13-.85.85.85 0 01.69-.49 1 1 0 01.85.35c.31.32.62.62.93.93l.08.07V1a.93.93 0 01.21-.69.87.87 0 01.46-.31H6z"
                fill="#3a3a39" fill-rule="evenodd"/>
          </svg>
          {{ 'txtDownloadTemplate'|translate }}
        </a>
      </DownloadTemplate>
    </ButtonGroup>
</template>

<script>
import DownloadTemplate from "components/DownloadTemplate.vue";
import ProductConfigPayload from "mixins/ProductConfigPayload";
import ButtonGroup from "./sidebarbuttons/ButtonGroup";
import {translatePrj} from "classes/vue-dict-filter";
import ConfigurableProductMixin from "../pages/mixins/ConfigurableProductMixin";

export default {
  name: 'PrintQButtonGroup',
  mixins: [ProductConfigPayload, ConfigurableProductMixin],
  components: {ButtonGroup, DownloadTemplate},
  inject: ['globalConfig', 'configuratorService', 'printqService', 'shopItemId'],
  computed: {
    configurationComplete: function () {
      return this.configuratorService.isConfigurationComplete();
    },
  },
  methods: {
    goToPersonalisazion() {
      this.configuratorService.validate().then(() => {
        if(this.configurationComplete) {
          if (this.globalConfig.externalTrackingEnabled) {
            window.dataLayer.push({
              'event': 'button-click',
              'type': 'Button',
              'text': translatePrj("ttxtDesignOnline"),
              'product': this.globalConfig.product_name
            });
          }
          const restore_param = this.configuratorService.saveConfiguration("asfasfiasgtempasfihoasg", true)
          restore_param.then(x =>
              this.printqService.packingAPI.getPersonalization({...this.configuratorService.byConfigoptionType("Printq").dynamicValues.conf3DModel},
                  this.globalConfig.locale, "configId=" + x.id + "&shopItemId="+this.shopItemId, this.configuratorService.byConfigoptionType("Printq").dynamicValues.customDesignId )
                  .then(response => {
                window.open(response.url, '_self');
              }).catch(xhr => {
                console.log(xhr)
              })
          )
        }
      })



    },
  }, watch: {},
}
</script>